export const allowSendResultRatingMail = state => state.result.allowSendResultRatingMail;